// 方案功能旗標工具
// 讀取 user.planSettings.features，判斷公司是否開通特定功能
// 預設為 true（未定義 = 開啟），避免舊公司因缺少 flag 而失去功能

/**
 * 檢查目前登入公司是否開通指定功能
 * @param {string} featureKey - features 物件中的 key，例如 'voiceEnabled'
 * @returns {boolean} true = 開通 / 未定義，false = 明確關閉
 */
export const hasFeature = (featureKey) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const features = user?.planSettings?.features;
    if (!features) return true; // 無 planSettings = 全開（向後相容）
    return features[featureKey] !== false;
  } catch {
    return true;
  }
};

/**
 * 讀取 planSettings 上的任意設定值（非 boolean 旗標），例如 reservationAddons / businessHours。
 * @param {string} key - planSettings 物件中的 key
 * @param {*} fallback - 取不到時的預設值
 * @returns {*} planSettings[key]，未定義則回 fallback
 */
export const getPlanSetting = (key, fallback = null) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const v = user?.planSettings?.[key];
    return v === undefined ? fallback : v;
  } catch {
    return fallback;
  }
};
